import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

class About extends Component {
  render() {
    let contentData = this.props.contentData;
    var { aClass } = this.props;
    return (
      <section className={`${aClass}`} id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 d-flex align-items-center">
              <Fade direction="up" triggerOnce="true" damping={0.1}>
                <div className="about_content">
                <h6>{contentData.role}</h6>
                  <h2 className="t_color">{contentData.aboutme}</h2>
                  <p>{contentData.aboutdetails}</p>
                  {/* <Link to="service" className="theme_btn active">
                    Services
                  </Link>
                  <Link to="/" className="theme_btn">
                    Download CV
                  </Link> */}
                </div>
              </Fade>
            </div>
            <div className="col-lg-5">
              <div className="about_img">
                <Fade direction="right" duration={1500}>
                  <img className="left-right-arrow" src={require("../image/stock-vector-transfer-two-left-right-arrows-with-green-and-red-dots-data-receive-digital-money-send-currency-1979749397-transformed.jpeg")} alt="" />
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default About;
